module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_07.0ae30180.jpg";